import clsx from "clsx";
import { Lock } from "lucide-react";
import { _ } from "i18n";
import { AttachModeKind, type AttachModeTarget } from "../../../types";
import styles from "./styles.module.scss";

interface AttachModeLockBadgeProps {
	target: AttachModeTarget;
}

export function AttachModeLockBadge({ target }: AttachModeLockBadgeProps) {
	const ariaLabel =
		target.kind === AttachModeKind.Team
			? _("game.attachMode.lock.team", { name: target.name })
			: _("game.attachMode.lock.player", { name: target.name });

	return (
		<span
			className={clsx(styles.badge, {
				"sensitive-me": target.kind === AttachModeKind.Player,
			})}
			aria-label={ariaLabel}
		>
			<Lock className={styles.badge__icon} aria-hidden />
			<span className={styles.badge__label}>{target.name}</span>
		</span>
	);
}
